// src/portal-app/tabs/HubEmptyState.js
//
// Fix-wave Finding 1 (final whole-branch review of Plan 2). The old
// HubScreen rendered this card whenever every hub card was permission-hidden
// — MoreTab.js kept it, but InsightsTab/TeamTab/OperationsTab were built
// later against useHubCards directly and never carried it over, so a
// manager whose role clears none of a hub's cards saw a bare section
// heading over nothing (e.g. "MANAGE" with no rows underneath).
//
// Lifted verbatim out of MoreTab.js so all four hub-card landings (More,
// Insights, Team, Operations) render the exact same empty state instead of
// each re-inventing it. Same translation keys MoreTab already used — no new
// keys added.
import React from 'react';
import { GlassCard } from '../shell/LiquidGlass';

const ShieldIcon = () => (
    <svg className="tab-empty-icon" width="30" height="30" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
        aria-hidden="true">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
);

// `testId` is a prop (not hardcoded) so each landing keeps its own
// data-testid — MoreTab.test.js already pins "more-empty" and changing that
// out from under it would be an unrelated behaviour change for this fix.
export function HubEmptyState({ t, testId = 'hub-empty' }) {
    return (
        <GlassCard veil className="tab-empty" data-testid={testId}>
            <ShieldIcon />
            <p className="tab-empty-title">{t('hub_empty_title', {}, 'Nothing to show here')}</p>
            <p className="tab-empty-msg">
                {t('hub_empty_msg', {}, "Your role doesn't have access to any sections in this area.")}
            </p>
            <p className="tab-empty-cta">
                {t('hub_empty_cta', {}, 'Contact your administrator for access')}
            </p>
        </GlassCard>
    );
}

export default HubEmptyState;
